/* global $ */

import Component from '../../js/lib/component';

const classList = {
  root: '.js-sort'
};

export default class Sort extends Component {
  init() {
    const $select = this.$.root.find('select');
    const $selected = $select.find('option:selected');
    const value = $selected.val();

    this.setState({ value });
  }
  events() {
    this.$.root.on('change', e => {
      e.stopPropagation();

      const $target = $(e.target);
      const $option = $target.find('option:selected');
      const value = $option.val();

      this.$.root.trigger('sort.change', { value });
    });
  }
}

Component.mount(Sort, {
  name: 'Sort',
  classList,
  state: {
    value: ''
  }
});
